<template>
  <div class="row mb-2">
    <div class="col">
      <input type="text" class="form-control" v-model.trim="search" />
    </div>
    <div class="col">
      <div class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle btn-sm"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span v-if="!selected_team_id">Select team...</span>
          <span v-else>{{ selected_team_name }}</span>
        </button>
        <ul class="dropdown-menu">
          <li
            class="dropdown-item"
            v-for="t in sorted_teams"
            :key="t.id"
            @click="selectTeam(t.name, t.id)"
          >
            {{ t.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="col">
      <button
        class="btn btn-sm btn-success"
        v-if="sorted_players.length && selected_team_id"
        @click="allotTeams()"
      >
        Add
      </button>
    </div>
  </div>
  <div
    class="row border rounded hoverblue"
    v-for="(p, index) in sorted_players"
    :key="p.id"
  >
    <div class="col-1">{{ index + 1 }}</div>
    <div
      class="col text-start"
      @click="addToCheckMark(p.id, p.team_id)"
      :class="{ 'bg-warning': check_marked.indexOf(p.id) !== -1 }"
    >
      <span v-if="player_error == p.id" class="text-danger">
        {{ err }}
      </span>
      {{ p.name }}
    </div>
    <div class="col">
      <span v-if="p.pool_id">
        {{ getPoolName(p.pool_id) }}
      </span>
    </div>
    <div class="col">
      <i
        class="bi bi-trash text-danger float-start"
        v-if="player_id_to_delete_team == p.id"
        @click="deleteTeam()"
      ></i>
      <span v-if="p.team_id">
        <span @click="clearTeamOfPlayer(p.id)">{{
          getTeamName(p.team_id)
        }}</span>
      </span>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
const all_players = ref([]);
const all_teams = ref([]);
const all_pools = ref([]);
const store = useStore();
const search = ref("");
const selected_team_name = ref("");
const selected_team_id = ref("");
const check_marked = ref([]);
const err = ref("");
const player_error = ref("");
const player_id_to_delete_team = ref("");
const deleteTeam = async () => {
  const { data, error } = await supabase
    .from("players")
    .update({ team_id: null, sale_price: null, sold_at: null })
    .eq("id", player_id_to_delete_team.value)
    .select();
  if (!error) {
    player_id_to_delete_team.value = "";
    fetchPlayers();
  }
};
const clearTeamOfPlayer = (player_id) => {
  if (player_id_to_delete_team.value != player_id) {
    player_id_to_delete_team.value = player_id;
  } else {
    player_id_to_delete_team.value = "";
  }
};
const getTeamName = (team_id) => {
  var name = "";
  all_teams.value.forEach((t) => {
    if (t.id == team_id) {
      name = t.name;
    }
  });
  return name;
};
const getPoolName = (pool_id) => {
  var name = "";
  all_pools.value.forEach((p) => {
    if (p.id == pool_id) {
      name = p.name;
    }
  });
  return name;
};
const selectTeam = (name, id) => {
  if (selected_team_id.value != id) {
    selected_team_id.value = id;
    selected_team_name.value = name;
  } else {
    selected_team_id.value = "";
    selected_team_name.value = "";
  }
};

onMounted(() => {
  setTimeout(() => {
    fetchTeams();
    fetchPools();
  }, 1000);
  setTimeout(() => {
    fetchPlayers();
  }, 3000);
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
};
const sorted_teams = computed(() => {
  var arr = [];
  all_teams.value.forEach((t) => {
    arr.push(t);
  });
  var sorted_arr = [];
  sorted_arr = arr.sort((a, b) => a.name.localeCompare(b.name));
  return sorted_arr;
});
const addToCheckMark = (player_id, team_id) => {
  const idx = check_marked.value.indexOf(player_id);
  if (idx === -1 && !team_id) {
    // value not found → add it
    check_marked.value.push(player_id);
  } else {
    // value already present → remove it
    check_marked.value.splice(idx, 1);
  }
  if (team_id) {
    err.value = "Team already allotted";
    player_error.value = player_id;
    setTimeout(() => {
      err.value = "";
      player_error.value = "";
    }, 2000);
  }
  search.value = "";
};
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
};
const sorted_players = computed(() => {
  var arr = [];
  all_players.value.forEach((p) => {
    if (check_marked.value.indexOf(p.id) != -1) {
      arr.push(p);
    }
    if (search.value.length >= 2) {
      var local_str =
        p.name.trim() +
        " " +
        getTeamName(p.team_id) +
        " " +
        getPoolName(p.pool_id);
      if (compareStrings(search.value, local_str)) {
        if (arr.indexOf(p.id) === -1) {
          arr.push(p);
        }
      }
    } else {
      if (arr.indexOf(p.id) === -1) {
        arr.push(p);
      }
    }
  });
  var sorted_arr = [];
  sorted_arr = dedupeById(arr).sort((a, b) => a.name.localeCompare(b.name));
  return sorted_arr;
});
function dedupeById(arr) {
  const seen = new Set();
  return arr.filter((obj) => {
    if (seen.has(obj.id)) return false; // duplicate → skip
    seen.add(obj.id);
    return true; // first time → keep
  });
}
// const compareStrings = (needle, haystack) => {
//   var found = false;
//   if (haystack.toLowerCase().includes(needle.toLowerCase())) {
//     found = true;
//   }
//   return found;
// };
const compareStrings = (needle, haystack) => {
  const normalizedNeedle = needle.toLowerCase();
  const normalizedHaystack = haystack.toLowerCase().replace(/\s+/g, "");
  return normalizedHaystack.includes(normalizedNeedle);
};

const allotTeams = () => {
  check_marked.value.forEach((player_id) => {
    updateTeam(player_id, selected_team_id.value);
  });
  setTimeout(() => {
    check_marked.value = [];
    fetchPlayers();
    selectTeam("", "");
  }, 3000);
};
const updateTeam = async (player_id, team_id) => {
  const { data, error } = await supabase
    .from("players")
    .update({ team_id: team_id, sale_price: 0, sold_at: "now()" })
    .eq("id", player_id)
    .select();
};
</script>
<style scoped>
.hoverblue:hover {
  background-color: lightblue;
}
</style>
